import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useCancelAiReviewMutation = (mode?: 'authorized' | 'guest' | null
) => {
  const { sims } = useAvApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['ai-review', 'finish'],
    mutationFn: async ({
      reviewId
    }: {
      shareToken: string;
      scenarioId: string;
      workspaceId: string;
      reviewId: string;
    }) => {
      if (!reviewId) return;

      if (mode === 'authorized') {
        const res = await sims.postSimulationStopSingleById(null, {
          id: reviewId,
        });

        return res.data;
      }

      if (mode === 'guest') {
        const res = await sims.postGuestSimulationStopSingleById(null, {
          id: reviewId,
        });

        return res.data
      }
    },
    onSuccess: (_, { workspaceId, scenarioId, shareToken, reviewId }) => {
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-reviews', workspaceId, scenarioId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-reviews-chat', shareToken, reviewId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['ai-review', shareToken, reviewId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario', workspaceId, scenarioId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario-short-summary', scenarioId],
        refetchType: 'all',
      });
    },
  });
};
